module.exports = __webpack_public_path__ + "a1ccfc87a5aea51a349760380438e965.woff2";